import { ErrorBoundary, useContext } from 'solid-js';
import { AppContext } from '../app-context-provider/app-context-provider';
import { logErrorToServer } from './log-error-to-server';

type ErrorCatcherProps = {
    componentName: string;
    children: any;
    logErrorToServer?: boolean;
}

export const ErrorCatcher = (props: ErrorCatcherProps) => {
    const { siteInfo, viewport } = useContext(AppContext);

    const logError = (error: Error) => {
        logErrorToServer({
            message: error.message,
            url: window.location.href,
            componentName: props.componentName,
            error,
            viewport,
        });
    };
    
    return (
        <ErrorBoundary fallback={(err: Error) => {
            const message = `Error caught in ${props.componentName} on ${siteInfo.name} - ${siteInfo.url}: `;
            console.error(message, err);

            if (props.logErrorToServer) {
                logError(err);
            }
            
            return (
                <div class="absolute z-[100] top-0 left-0 w-full bg-[lightcoral] text-white p-4">
                    {message}: {err?.toString()}
                </div>
            );
        }}>
            {props.children}
        </ErrorBoundary>
    );
};